import * as policyEvents from "./policyEventsConstants";
import {ROLES, PATRON_ROLE, PATRON_SUBTYPE} from "./roleConstants";

type PolicyFn = (roles: (number | undefined)[], patronRole: number | undefined, patronSubType: number | undefined) => boolean;

export class DefaultPolicy {
    private _policy: Record<string, PolicyFn>;
    private _roles: (number | undefined)[];
    private _patronRole: number | undefined;
    private _patronSubType: number | undefined;

    constructor(roles: (number | undefined)[], patronRole: number | undefined, patronSubType: number | undefined) {
        this._policy = {};
        this._roles = roles;
        this._patronRole = patronRole;
        this._patronSubType = patronSubType;
console.log(roles);
        this.initializePolicy();
    }

    permit(policyEvent: string): boolean {
        if (!policyEvent)
            return false;

        if (this._policy[policyEvent])
            return this._policy[policyEvent](this._roles, this._patronRole, this._patronSubType);

        return false;
    }

    initializePolicy(): void {
        this._policy[policyEvents.VIEW] = function (roles) {
            return roles.some((role: number | undefined) => role !== ROLES.Patron);
        };
        this._policy[policyEvents.ADVANCE_SEARCH] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.APPROVE_USERS] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.Admin)
                || roles.includes(ROLES.EseDirector) || roles.includes(ROLES.Delegate);
        };
        this._policy[policyEvents.DELEGATE_USERS] = function (roles) {
            return roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.EseDirector) || roles.includes(ROLES.Admin);
        };
        this._policy[policyEvents.APPROVE_STUDENTS] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.DELETE] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.VIEW_STUDENT_HISTORY] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.VIEW_STUDENTS] = function (roles) {
            return roles.includes(ROLES.StudentViewer) || roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.Admin)
                || roles.includes(ROLES.EseDirector) || roles.includes(ROLES.Delegate);
        };
        this._policy[policyEvents.MANAGE_CATALOG] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.MANAGE_ORDER] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.VIEW_TEXTBOOKS] = function (roles, patronRole, patronSubType) {

            if (roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.EseDirector)) {
                return true;
            } else if (patronSubType === PATRON_SUBTYPE.DistrictPersonnel || patronSubType === PATRON_SUBTYPE.TviAndOrOnM)
                return true;
            else if ((patronRole === PATRON_ROLE.Parent && patronSubType === PATRON_SUBTYPE.HomeSchool) || (patronRole === PATRON_ROLE.DbsOrAgencyStaffMember && patronSubType === PATRON_SUBTYPE.ServiceProvider) || (patronRole === PATRON_ROLE.SchoolDistrictEmployee && patronSubType === PATRON_SUBTYPE.Paraprofessional) || (patronRole === PATRON_ROLE.CharterSchoolEmployee && patronSubType === PATRON_SUBTYPE.SchoolAdministrator) || (patronRole === PATRON_ROLE.DbsOrAgencyStaffMember && patronSubType === PATRON_SUBTYPE.Administrator))
                return true;
            else if (((patronRole === PATRON_ROLE.PrivateSchoolEmployee || patronRole === PATRON_ROLE.CharterSchoolEmployee) && patronSubType === PATRON_SUBTYPE.SchoolAdministrator) || (((patronRole === PATRON_ROLE.PrivateSchoolEmployee || patronRole === PATRON_ROLE.CharterSchoolEmployee) && patronSubType === PATRON_SUBTYPE.SchoolPersonnel)))
                return true;
            else
                return false;
        };
        this._policy[policyEvents.VIEW_APH] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.AphViewer);
        };
        this._policy[policyEvents.MANAGE_APH_LOANS] = this._policy[policyEvents.MANAGE_APH_CATALOG_ITEMS] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.VIEW_LOAN_LIBRARY] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.LoanLibraryViewer);
        };
        this._policy[policyEvents.MANAGE_LOAN_LIBRARY_CATALOG] = this._policy[policyEvents.MANAGE_LOAN_LIBRARY_LOANS] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
        this._policy[policyEvents.VIEW_BRAILLER] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.BraillerViewer);
        };
        this._policy[policyEvents.MANAGE_BRAILLER_CATALOG] = function (roles) {
            return roles.includes(ROLES.SystemAdmin) || roles.includes(ROLES.FimcAdmin);
        };
    }
}
